const OFFICES = [
  { city: "Hyderabad", region: "Head Office" },
  { city: "Delhi NCR", region: "North" },
  { city: "Mumbai", region: "West" },
  { city: "Chennai", region: "South" },
  { city: "Kolkata", region: "East" },
];

const SERVICES = [
  "Full Truck Load (FTL)",
  "ODC / Project Cargo",
  "Trailer Transportation",
  "Warehousing & Storage",
];

export const Footer = () => (
  <footer
    id="contact"
    data-testid="site-footer"
    className="scroll-mt-20 bg-[#0A0D12] border-t border-slate-800"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <a href="#home" data-testid="footer-logo-link" className="inline-flex items-center">
          <img src="/logo-light.png" alt="Agaman Freight — Connected. Committed. Delivered." className="h-11 w-auto" />
        </a>
        <p className="mt-4 text-sm text-slate-500 leading-relaxed max-w-xs">
          Pan-India trucking and warehousing. Steel, steady motion, dependability.
        </p>
      </div>

      <div>
        <p className="mono text-[10px] uppercase tracking-[0.25em] text-amber-500 font-semibold">Services</p>
        <ul className="mt-4 flex flex-col gap-2.5">
          {SERVICES.map((s) => (
            <li key={s}>
              <a href="#services" data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-sm text-slate-400 hover:text-amber-400 transition-colors duration-200">
                {s}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="mono text-[10px] uppercase tracking-[0.25em] text-amber-500 font-semibold">Regional desks</p>
        <ul className="mt-4 flex flex-col gap-2.5">
          {OFFICES.map((o) => (
            <li key={o.city} data-testid={`footer-office-${o.city.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <span className="text-sm text-slate-300">{o.city}</span>
              <span className="mono block text-[10px] uppercase tracking-[0.15em] text-slate-600">{o.region}</span>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="mono text-[10px] uppercase tracking-[0.25em] text-amber-500 font-semibold">Contact</p>
        <ul className="mt-4 flex flex-col gap-2.5 text-sm">
          <li>
            <a href="mailto:contact@agaman.co" data-testid="footer-email-link" className="text-slate-300 hover:text-amber-400 transition-colors duration-200">
              contact@agaman.co
            </a>
          </li>
          <li>
            <a href="tel:+919820045678" data-testid="footer-phone-link" className="text-slate-300 hover:text-amber-400 transition-colors duration-200">
              +91 98200 45678
            </a>
          </li>
          <li>
            <a href="#quote" data-testid="footer-quote-link" className="text-slate-300 hover:text-amber-400 transition-colors duration-200">
              Request a freight quote
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-slate-800/70">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
        <p className="mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
          © {new Date().getFullYear()} Agaman Freight. All rights reserved.
        </p>
        <p className="mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
          Pan-India · FTL · ODC · Trailers · Warehousing
        </p>
        <p data-testid="footer-powered-by" className="mono text-[10px] uppercase tracking-[0.2em] text-amber-500/80">
          Powered by Tvarit Control Tower System
        </p>
      </div>
    </div>
  </footer>
);
